// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Setting__container-ed2e68 {
  padding: 12px 16px;
  display: flex;
  gap: 24px;
  align-items: start;
  justify-content: space-between;
}

.Setting__content-f40539 {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.Setting__email-f90349 {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Setting__status-f64914 {
  color: var(--base-110);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
}

.Setting__disconnect-bdef92 {
  box-sizing: border-box;
  cursor: pointer;
  padding: 8px 16px;
  display: flex;
  gap: 24px;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--danger-40);
}

.Setting__popover-bc35e6 {
  max-width: 256px;
  min-width: 256px;
}

.Setting__delete-icon-f2afee {
  width: 24px;
  fill: var(--danger-40);
}

.Setting__google-icon-f3d190 {
  max-width: 24px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/Toolbar/Setting/EmailItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,wBAAA;EACA,0CAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;AACF","sourcesContent":[".container {\n  padding: 12px 16px;\n  display: flex;\n  gap: 24px;\n  align-items: start;\n  justify-content: space-between;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.email {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.status {\n  color: var(--base-110);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.disconnect {\n  box-sizing: border-box;\n  cursor: pointer;\n  padding: 8px 16px;\n  display: flex;\n  gap: 24px;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--danger-40);\n}\n\n.popover {\n  max-width: 256px;\n  min-width: 256px;\n}\n\n.delete-icon {\n  width: 24px;\n  fill: var(--danger-40);\n}\n\n.google-icon {\n  max-width: 24px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Setting__container-ed2e68`,
	"content": `Setting__content-f40539`,
	"email": `Setting__email-f90349`,
	"status": `Setting__status-f64914`,
	"disconnect": `Setting__disconnect-bdef92`,
	"popover": `Setting__popover-bc35e6`,
	"delete-icon": `Setting__delete-icon-f2afee`,
	"deleteIcon": `Setting__delete-icon-f2afee`,
	"google-icon": `Setting__google-icon-f3d190`,
	"googleIcon": `Setting__google-icon-f3d190`
};
module.exports = ___CSS_LOADER_EXPORT___;
